import dayjs from "dayjs";
import utc  from 'dayjs/plugin/utc';
import timezone  from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

export default class Transaction{
    public _id?: string = undefined;
    public date: Date = new Date();
    public userId?: string = undefined;
    public patientId?: string = undefined;
    public meetingId?: string = undefined;
    public amount?: number = undefined;
    public paidOn?: Date = undefined;

    public constructor(init?:Partial<Transaction>) {
        if (init && init.date) init.date = dayjs(init.date).isValid() ? dayjs(init.date).toDate() : undefined;
        if (init && init.paidOn) init.paidOn = dayjs(init.paidOn).isValid() ? dayjs(init.paidOn).toDate() : undefined;
        Object.assign(this, init);
    }
}
